import React from 'react'
import _ from 'lodash'
import TextContent from '../TextContent';

const ReusableContent = ({ entity }) => {
  const description = _.get(entity, 'fieldReusableContent.entity.description.value', null)

  if (!description) {
    return null
  }

  return (
    <TextContent>
      <div dangerouslySetInnerHTML={{ __html: description}}></div>
    </TextContent>
  )
}

export default ReusableContent
